import React from 'react'
import { getAttribute, renderAsHtml, renderAsText } from '../../utility.js'
import AddOn from './add-on'
import SectionBlock from '../section-block'
import { filterArrayByType } from '../../utility'

import * as styles from './add-on-block.module.css'

export default ({ body = null, dark, data = null }) => {
  //  console.log('BODY from block >>>', body) 
  let addOns;
  if (!data && body) {
    addOns = filterArrayByType(body, 'add-ons')
  } else if (data && !body) {
    addOns = [data]
  } else {
    return null
  }
  //  console.log('addOns', addOns)

  let items = addOns.map((d) => d.items)

  if (items.length === 0) {
    return null
  }

  let { title, title1, subheading } = addOns.pop().primary

  return (
    <SectionBlock>
      <div className="container">
        <div className={styles.sectionHeading}>
          {title && (
            <h2 className={styles.sectionTitle}>{renderAsText(title.text)}</h2>
          )}
          {title1 && (
            <h2 className={styles.sectionTitle}>{renderAsText(title1.text)}</h2>
          )}
          {subheading && (
            <div className={styles.sectionSubheading}>{subheading}</div>
          )}
        </div>
        <div className={`row ${styles.addOnRow}`}>
          {items?.pop().map((addOn, i) => {
            return (
              <AddOn
                icon={addOn.icon_selector}
                key={i}
                dark={dark}
                title={addOn?.add_on_title?.text}
                copy={
                  addOn?.add_on_text?.richText ||
                  addOn?.add_on?.text ||
                  getAttribute(addOn, "description").richText
                }
              />
            )
          })}
        </div>
      </div>
    </SectionBlock>
  )
}